import React, {useState} from 'react';
import BackToDashboard from "../../components/Dashboard/BackToDashboard";
import SubscriptionSelect from "../../components/Dashboard/User/SubscriptionSelect";
import SubscriptionPurchase from "../../components/Dashboard/User/SubscriptionPurchase";
import subscriptions from "../../utilities/data/products";

const Purchase = () => {

    const [buying, setBuying] = useState(false);
    const [subscription, setSubscription] = useState(subscriptions.base);

    const handleSelected = (selected) => {
        setSubscription(selected);
        setBuying(true);
    }

    return (
        <div className="text-left p-4">
            <BackToDashboard />
            {!buying
                ? <SubscriptionSelect onSelect={handleSelected} />
                : <SubscriptionPurchase subscription={subscription} />
            }
        </div>
    );
};

export default Purchase;